import { render, staticRenderFns } from "./QueryList.vue?vue&type=template&id=5016be0a&scoped=true"
import script from "./QueryList.vue?vue&type=script&lang=js"
export * from "./QueryList.vue?vue&type=script&lang=js"
import style0 from "./QueryList.vue?vue&type=style&index=0&id=5016be0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016be0a",
  null
  
)

export default component.exports